import React from 'react'
import { API_URL } from '../Constants'
import { SectionBase, DifficultyBadge, Time, NextQuestion } from '../Shared/SectionBase'
import { Link } from 'react-router-dom'
import Menu from '../Shared/Menu';
import Writer from '../Shared/Writer';
import Listening from '../Shared/Listening';
export default class ListenAndType extends SectionBase {

  constructor(props) {
    super(props)
    this.nextQuestion = this.nextQuestion.bind(this);
    this.onDifficultyChange = this.onDifficultyChange.bind(this);
    this.onAnswerInput = this.onAnswerInput.bind(this)
    this.retry = this.retry.bind(this);
    this.submit = this.submit.bind(this);
    //this.listen = this.listen.bind(this)
  }

  TEST_TIME_SECONDS = 60

  state = {
    difficulty: 1,
    answer: ''
  }


  async nextQuestion() {
    console.log('nextQ');
    const secondsLeft = this.TEST_TIME_SECONDS;
    const listensremaining = 3;
    const answer='';
    const step = 1;
    const { difficulty } = this.state;
    const { token } = this.props;

    const res = await fetch(`${API_URL}/listenandtype/createquestion/${difficulty}`,
      { headers: { Authorization: `Token ${token}` } });
    try {
      const result = await res.json();
      const listening = result[0];
      this.setState({ listening, listening_id: listening.id, listensremaining, secondsLeft, step,answer }, this.restartTimer);

    } catch (e) {
      console.log(e);
      console.log(res);
    }
  }


  onAnswerInput(e) {
    const answer = e.target.value;
    this.setState({ answer });
  }

  onTimeIsUp() {
    this.submit();
  }

  onDifficultyChange(e) {
    this.setState({ difficulty: e.target.value }, this.nextQuestion);

  }


  render() {
    const { token } = this.props;

    const { listening, secondsLeft, step, profile, difficulty, listensremaining, answer, answerDiff } = this.state;

    return (
      <>
        {token!==null && listening && <div className={`listenandtype listenandtype-step${step}`}>
          <Menu token={token}  profile={profile} onDifficultyChange={this.onDifficultyChange}></Menu>
          <Time seconds={secondsLeft}></Time>
          <DifficultyBadge difficulty={difficulty}></DifficultyBadge>
          <div className='px-5' >
            <h1 className='text-center'> Listen and type what you hear</h1>
            <div className='my-5 text-center'>
              <Listening step={step} listensremaining={listensremaining} file={listening.file} onPlay={() => { this.setState({listensremaining:listensremaining-1}) }} />
            </div>
            

            
            {step === 1 && <div className='text-center'>
              <Writer answer={answer} onInput={this.onAnswerInput}></Writer>
            </div>}

            {step >= 2 && answerDiff && <>
              <div className='result mb-2'>
                <div className='custom-box-1 my-5 bg-light m-auto p-3'>
                  <h4>Your Answer</h4>
                  <div>
                  {answerDiff.map((item, i) => {
                    const {diff} = item;
                    item.elementKey = `diff-${i}`;
                    if (diff === '+') {
                      return <div key={item.elementKey} className='d-inline-block me-1 bg-danger text-white'>{item.text}</div>
                    } else if (diff===' ') {
                      return <div key={item.elementKey} className='d-inline-block me-1'>{item.text}</div>;
                    } else {return <></>};
                  })}
                  
                  </div>
                 
                  <hr></hr>
                  <h4>Words You Missed</h4>
                  {answerDiff.map((item, i) => {
                    item.elementKey = `diff-${i}`;
                    const {diff} = item;
                    if (diff==="-") {
                      return <div key={item.elementKey} className='d-inline-block me-1 fw-bold bg-danger btn text-white'>{item.text}</div>
                    } else if (diff===" "){
                      return <div key={item.elementKey} className='d-inline-block me-1'>{item.text}</div>
                    } else {
                      return <></>;
                    }
                  })}
                  <hr></hr>
                  <div>
                  <h4>Correct Answer</h4>
                  <div className='fw-bold'> 
                  {listening.text}
                  
                  </div>
                
                  </div>
                  </div>
              </div>

            </>
            }



            <div className='buttons d-flex justify-content-between'>
              <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.retry}>RETRY</button>

              {step === 1 && <button type="button" disabled={answer.trim().length===0} className={`btn btn-dark rounded-pill`} onClick={this.submit}>SUBMIT</button>
              }
            </div>
            <NextQuestion nextQuestion={this.nextQuestion}></NextQuestion>
            {false && <div>{JSON.stringify(this.state)}</div>}
          </div>

        </div>}

        {token === null && <div className='p-5'>Please <Link to="/home/">login</Link> and refresh this page</div>}

      </>

    )
  }


  retry() {
    this.setState({ listensremaining: 3, step: 1, secondsLeft: this.TEST_TIME_SECONDS, answer:'' });
    this.restartTimer();
  }

  async submit() {
    const { answer, listening_id } = this.state;
    
    this.stopTimer();
    const res = await fetch(`${API_URL}/listenandtype/submittedlistening`, {
      method: 'POST',
      body: JSON.stringify({ answer, listening:listening_id }),
      headers: { Authorization: `Token ${this.props.token}`, "Content-Type": "application/json" }
    });
    const answerDiff = await res.json();
    this.setState({ answerDiff, step: 2 });

  }
}
